import { all, fork } from 'redux-saga/effects'

import scrollBodyToSaga from './scrollBodyToSaga'

export default function* uiSaga() {
  yield all([fork(scrollBodyToSaga)])
}
